import { useCallback, useContext } from 'react';
import AppliedFiltersContext, {
  FinancePayload
} from '~/contexts/AppliedFiltersContext';
import { useFinanceInfo } from '~/contexts/FinanceAndTradeContext';
import SearchContext from '~/contexts/SearchContext';
import type { FinanceType } from '~/contracts';

export default function useBudgetTradeIn() {
  const { appliedFilters, updateRangeFilter } = useContext(
    AppliedFiltersContext
  );
  const { hasAppliedTrade, setAppliedTrade, toggleAppliedTrade } =
    useContext(SearchContext);
  const { minDownPayment, minDownPaymentNoTrade } = useFinanceInfo();

  return useCallback(
    (targetStatus?: boolean) => {
      const appliedFinanceFilters: Partial<FinanceType> =
        appliedFilters.finance ?? {};

      if (targetStatus === undefined) {
        toggleAppliedTrade();
      } else {
        setAppliedTrade(targetStatus);
      }

      const newDownPayment =
        appliedFinanceFilters.downPayment == null
          ? undefined
          : Math.max(
              appliedFinanceFilters?.downPayment,
              hasAppliedTrade
                ? minDownPaymentNoTrade ?? minDownPayment
                : minDownPayment
            );

      const payload: FinancePayload = {
        filterKey: 'finance',
        value: {
          downPayment: newDownPayment,
          monthlyPayment: appliedFinanceFilters.monthlyPayment
        }
      };

      // Ensure the user is not using a down payment that is below their min down after toggling their trade off.
      // If they are, update the filter. Otherwise, make a call to Search API to get their updated min down.
      if (
        hasAppliedTrade &&
        newDownPayment &&
        appliedFinanceFilters.downPayment !== newDownPayment &&
        appliedFinanceFilters.monthlyPayment !== null
      ) {
        updateRangeFilter(payload);
      }
    },
    [
      appliedFilters.finance,
      hasAppliedTrade,
      minDownPayment,
      minDownPaymentNoTrade,
      setAppliedTrade,
      toggleAppliedTrade,
      updateRangeFilter
    ]
  );
}
